//@flow
import * as React from 'react'
import ReactTable from 'react-table'
//$FlowFixMe
import 'react-table/react-table.css'

import { Label, Loader } from 'components/common'
import { TableFilter } from './'
import { useI18n } from '~/core/i18n'
import { Filter } from './Filter'

type GlassOverlayProps = {
  type?: 'loading' | 'empty'
}

const setTrStyles = () => ({
  style: {
    alignItems: 'center'
  }
})

const GlassOverlay = ({ type = 'empty' }: GlassOverlayProps) => {
  const [msg] = useI18n()

  const renderContent = () => {
    switch (type) {
      case 'loading':
        return <Loader />
      case 'empty':
        return <h3>{msg('common.table.noRecords')}</h3>
      default:
        return null
    }
  }

  return (
    <div
      style={{
        position: 'absolute',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
        backgroundColor: 'rgba(255,255,255,0.65)'
      }}
    >
      {renderContent()}
    </div>
  )
}

type TableProps = {
  columns: any[],
  id?: string,
  label?: string,
  loading?: boolean,
  totalResults?: number,
  wrapperProps?: {
    [key: string]: any
  },
  columnsFilter?: Filter[],
  isFilterable?: boolean,
  filters?: Filter[],
  ErrorComponent?: React.Node,
  PaginationComponent?: React.Node,
  ToolsComponent?: React.Node,
  onFiltersChange?: (filters: Filter[]) => void
}

const Table = ({
  id,
  label,
  isFilterable,
  columnsFilter = [],
  filters,
  loading,
  ErrorComponent,
  PaginationComponent,
  ToolsComponent,
  totalResults,
  wrapperProps,
  columns,
  onFiltersChange = () => {},
  ...props
}: TableProps) => {
  const [msg] = useI18n()

  return (
    <section id={id} {...wrapperProps}>
      {label && (
        <Label
          as="div"
          style={{
            marginTop: '1rem'
          }}
        >
          {label}
        </Label>
      )}
      {isFilterable && (
        <TableFilter
          columns={columns}
          columnsFilter={columnsFilter}
          filters={filters || []}
          onChange={onFiltersChange}
        />
      )}
      <ReactTable
        className="-striped -highlight"
        columns={columns}
        getTheadTrProps={setTrStyles}
        getTrProps={setTrStyles}
        LoadingComponent={() => (loading ? <GlassOverlay type="loading" /> : null)}
        NoDataComponent={() => (!loading ? <GlassOverlay type="empty" /> : null)}
        pageSize={5}
        showPageSizeOptions={false}
        showPagination={false}
        {...props}
      />
      {!isNaN(totalResults) && (
        <div
          id={`${id || 'table'}-total-results`}
          style={{
            padding: '10px 5px',
            fontSize: 12
          }}
        >
          {msg('common.table.recordsCount')}: <strong>{totalResults}</strong>
        </div>
      )}
      {ErrorComponent}
      {PaginationComponent}
      {ToolsComponent}
    </section>
  )
}

export default Table
